import axios from "axios";
import { client } from "@/api/client";

export interface ChangePasswordParams {
  new_password: string;
}

export const accountApi = {
  // 강제/자발적 변경 공용. 현재 비밀번호는 보내지 않고 JWT 로 본인 확인
  changePassword: async (params: ChangePasswordParams): Promise<void> => {
    await client.post("/account/password", params);
  },
};

const DEFAULT_ERROR_MESSAGE = "비밀번호 변경에 실패했어요. 잠시 후 다시 시도해 주세요.";

// 서버 정책 재검증 실패(400)의 message 는 디자인 문구라 그대로 노출한다. 그 외는 기본 문구
export function getPasswordChangeErrorMessage(error: unknown): string {
  if (
    axios.isAxiosError(error) &&
    error.response?.status === 400 &&
    typeof error.response.data?.message === "string"
  ) {
    return error.response.data.message;
  }
  return DEFAULT_ERROR_MESSAGE;
}
